module.exports = __webpack_public_path__ + "static/media/abattoir-cover.ac39dc90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/abattoir-cover.jpg
// module id = 109
// module chunks = 51